@use 'styles/variables';
@use 'styles/mixins';

.Container {
  position: sticky;
  bottom: 0;

  z-index: variables.$ZOverModal;

  @include mixins.flex-align-center;
  justify-content: space-between;

  padding: 1rem 4rem;

  border-top: solid 0.5px variables.$grey3;

  background-color: variables.$white;

  &_Name {
    @include mixins.flex-align-center;

    &_Icon {
      display: flex;
    }

    &_Label {
      margin-left: 1rem;
    }
  }

  &_Powered {
    display: flex;

    &_Name {
      margin-left: 0.2rem;
    }
  }
}
